import { render, staticRenderFns } from "./new-sportage-imgs-swiper.vue?vue&type=template&id=722d7576&scoped=true&"
import script from "./new-sportage-imgs-swiper.vue?vue&type=script&lang=js&"
export * from "./new-sportage-imgs-swiper.vue?vue&type=script&lang=js&"
import style0 from "./new-sportage-imgs-swiper.vue?vue&type=style&index=0&id=722d7576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722d7576",
  null
  
)

export default component.exports